import {
  DataSource,
  ILoadable,
} from '../../Utils';
import {
  GraphSubject,
} from '../../viz/Utils';
import {
  IHasNoError,
  IInputFromURLRouting,
  ISuccessfulMergeAction,
  IUIState,
} from './getReducer';
import merge_CCPY_CC, {
  IMergeInput as IMergeInput_CCPY_CC,
} from './merge_CCPY_CC';
import merge_CCPY_CP, {
  IMergeInput as IMergeInput_CCPY_CP,
} from './merge_CCPY_CP';
import merge_CCY_C, {
  IMergeInput as IMerge_CCY_C,
} from './merge_CCY_C';
import merge_CPY_C, {
  IMergeInput as IMergeInput_CPY_C,
} from './merge_CPY_C';
import merge_CPY_P, {
  IMergeInput as IMergeInput_CPY_P,
} from './merge_CPY_P';
import {
  updateMergedData,
} from './reducer';
import {
  IMergeOutput,
} from './Utils';

export type IMergeInput =
  IMergeInput_CPY_C | IMergeInput_CPY_P | IMergeInput_CCPY_CC |
  IMergeInput_CCPY_CP | IMerge_CCY_C;

interface IComputeInput {
  // Info that's actually used in the computation:
  computationInput: IMergeInput;

  // Pass through to the hash function:
  queueNumber: number;
  uiState: IUIState;
  inputFromURLRouting: IInputFromURLRouting;
}

const compute = (
    {computationInput, queueNumber, uiState, inputFromURLRouting}: IComputeInput,
  ): ISuccessfulMergeAction => {


  let computedValue: ILoadable<IMergeOutput>;
  if (computationInput.source === DataSource.CPY &&
      computationInput.subject === GraphSubject.Product) {

    computedValue = merge_CPY_C(computationInput);
  } else if (computationInput.source === DataSource.CPY &&
              computationInput.subject === GraphSubject.Country) {

    computedValue = merge_CPY_P(computationInput);
    
  } else if (computationInput.source === DataSource.CCPY &&
              computationInput.subject === GraphSubject.Product) {
    computedValue = merge_CCPY_CC(computationInput);
  } else if (computationInput.source === DataSource.CCPY &&
              computationInput.subject === GraphSubject.Country) {

    computedValue = merge_CCPY_CP(computationInput);
  } else {
    computedValue = merge_CCY_C(computationInput);
  }

  const mergedData: IHasNoError = {
    hasError: false, value: computedValue,
  };
  const {
    svgWidth, svgHeight, svgLeft, svgTop,
    deselectedCategories,
    populationAdjustment, inflationAdjustment,
    layout, productLevel, countryLevel, ordering,
  } = uiState;
  const {
    country, queryLevel, endYear, startYear,
    productClass, tradeDirection, tradeFlow,
    product, target, partner,

  } = inputFromURLRouting;
  const computationalResult = {
    mergedData, queueNumber,
    hashInput: {
      svgWidth, svgHeight, svgLeft, svgTop,
      deselectedCategories,
      populationAdjustment, inflationAdjustment,
      layout, productLevel, countryLevel, ordering,
      country, queryLevel, endYear, startYear,
      productClass, tradeDirection, tradeFlow,
      product, target, partner,
    },
  };
  return updateMergedData(computationalResult);
};

export default compute;
